export default (() => {
  const body = document.querySelector('body');

  body.addEventListener('click', e => {
    // A Tag Extract
    const pathLinks = Array.from(e.path);
    const linkNode = pathLinks.filter(pathNode => pathNode.tagName === 'A')[0];
    let hasButtonRole;

    // Checkers for if link exists in click event and if it's domain matches site.
    const isAlink = typeof linkNode !== 'undefined';
    const linkMatchesSite = () =>
      isAlink ? location.hostname === linkNode.hostname : false;

    // Do Nothing if not a link.
    if (!isAlink) {
      return false;
    }

    // If an a tag is still used a trigger, check
    if (linkNode.hasAttribute('role') && linkNode.getAttribute('role') === 'button') {
      hasButtonRole = true;
    }

    // Do Nothing if not a link.
    if (hasButtonRole) {
      return false;
    }

    if (!linkMatchesSite()) {
      e.preventDefault();
      const win = window.open(linkNode.getAttribute('href'), '_blank');
      win.focus();
    }
  });
})();
